"use client";
import type { PlacementAccessSnapshot } from "@-/access";
import type { Prisma } from "@-/prisma";
import type { StudentProfileShellInclude, StudentProfileShellPlacementInclude } from "@/includes/student";
import type { StudentProfileTabMetrics } from "@/types/student-profile";
import type { RouterOutput } from "@/types/trpc";
import { createContext } from "react";

type StudentProfileSupplemental = NonNullable<
  RouterOutput<"placement.getStudentProfileSupplemental">
>;

export type StudentLayoutContext = {
  student: Prisma.StudentProfileGetPayload<{
    include: StudentProfileShellInclude;
  }>;
  currentPlacement: Prisma.PlacementGetPayload<{
    include: StudentProfileShellPlacementInclude;
  }>;
  isShellSupplementalRetrying: boolean;
  placementAccess: PlacementAccessSnapshot;
  retryShellSupplemental: () => void;
  reviewFindings: StudentProfileSupplemental["reviewFindings"];
  shellSupplementalError: unknown;
  tabMetrics: StudentProfileTabMetrics;
};

const LayoutContext = createContext<StudentLayoutContext>(null!);

export default LayoutContext;
